// Returns a score (higher = better). 0 means "no match"
export function fuzzyScore(pattern, text) {
    pattern = pattern.trim().toLowerCase();
    text = text.toLowerCase();
    let score = 0;
    let patternIndex = 0;
    let lastMatchIndex = -1;
    for (let i = 0; i < text.length; i++) {
        if (text[i] === pattern[patternIndex]) {
            // Boost score for consecutive matches
            if (lastMatchIndex === i - 1) {
                score += 5; // consecutive bonus
            }
            else {
                score += 1;
            }
            lastMatchIndex = i;
            patternIndex++;
            // If full pattern matched
            if (patternIndex === pattern.length) {
                return score;
            }
        }
    }
    return 0; // pattern not found in order
}
// Filters and sorts items based on fuzzy match score
export function fuzzySearch(query, items, selector = (x) => x) {
    return items
        .map((item) => ({
        item,
        score: fuzzyScore(query, selector(item)),
    }))
        .filter((result) => result.score > 0)
        .sort((a, b) => b.score - a.score)
        .map((result) => result.item);
}
//# sourceMappingURL=fuzzy-search.js.map